__turbopack_context__.v({
  "description": "styles-module-scss-module__HpqyLW__description",
  "dotsDescription": "styles-module-scss-module__HpqyLW__dotsDescription",
  "img": "styles-module-scss-module__HpqyLW__img",
  "imgLabelClassName": "styles-module-scss-module__HpqyLW__imgLabelClassName",
  "section": "styles-module-scss-module__HpqyLW__section",
  "slidersWrapper": "styles-module-scss-module__HpqyLW__slidersWrapper",
});
